import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { isNumber } from 'lodash';
import {
  PILCROW_CHARACTER,
  PILCROW_REGEX,
  MAX_TEXT_LENGTH,
} from '../../../constants';
import { FocusElement } from '../../../helpers/focusElement';

export default function OpenEnded({ question }) {
  const { minLength } = question;
  let { maxLength } = question;
  maxLength = isNumber(maxLength) ? maxLength : MAX_TEXT_LENGTH;
  const { getText } = Pollfish.ui;
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    const freeText = $(inputRef?.current);
    const questionWrapper = Pollfish.ui.getClosestQuestionWrapperElement(
      freeText,
    );

    if (!Pollfish.ui.isQuestionDisplaySamePage(questionWrapper)) {
      FocusElement(freeText);
    }

    if (
      freeText.offset().top +
        freeText.height() +
        $('.submit-btn-container').height() <
      $(window).height() - 320
    ) {
      if (Pollfish.helper.shouldAutofocus()) {
        setTimeout(() => {
          // in order to auto focus to the textarea we need both .tap and .focus, don't know why
          //
          // nrossolatos: The above was true because Apple doesn't like it when developers try
          // to enforce keyboard appearances when there is no user interaction. Faking a tap
          // would solve this issue. Unfortunately this will still not work for WKWebview.
          freeText.tap();
          freeText.focus();
        }, 100);
      }
    }
  }, []);

  const onChange = useCallback((event) => {
    setValue(event.target.value);
  }, []);

  const onKeyDown = useCallback((event) => {
    if (event.keyCode === 13 && inputRef.current) {
      inputRef.current.blur();
    }
  }, []);

  const onKeyUp = useCallback(
    (event) => {
      if (event.key === PILCROW_CHARACTER) {
        setValue(value.replace(PILCROW_REGEX, ''));
      }
    },
    [value],
  );

  const onPaste = useCallback((event) => event.preventDefault(), []);

  const onClick = useCallback((event) => {
    event.preventDefault();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const onBlur = useCallback(() => {
    Pollfish.ui.validateQuestionAnswers(
      Pollfish.ui.getClosestQuestionWrapperElement(inputRef?.current),
    );
  }, []);

  const valueLength = value.length;
  const remaining = maxLength - valueLength;
  // we decided we don't want to show negative values on the remaining number
  const sanitisedRemaining = remaining >= 0 ? remaining : 0;
  const isZeroRemaining = sanitisedRemaining === 0;

  let className = 'input-text-note--valid';

  if (isNumber(minLength) && valueLength < minLength) {
    className = 'input-text-note--invalid';
  }

  if (isZeroRemaining) {
    className = 'input-text-note--invalid';
  }

  return (
    <div className="form-container">
      <textarea
        ref={inputRef}
        value={value}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        // autoFocus={Pollfish.helper.shouldAutofocus()}
        id={`freeText-${question.refId || question.id}`}
        className="input-text"
        placeholder={getText('freeTextBox')}
        aria-label={getText('freeTextBox')}
        rows="3"
        maxLength={maxLength}
        onClick={onClick}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        onBlur={onBlur}
      ></textarea>
      <span className={`input-text-note ${className}`}>
        <span>{sanitisedRemaining}</span>
      </span>
    </div>
  );
}

OpenEnded.propTypes = {
  question: PropTypes.object.isRequired,
};
